import axios from './axiosConfig'
import { getEnv } from '@utils/env'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')
const BASE = `${CLINIC_BUSINESS_API}/api/v1/clinic/acquisition-context`

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export interface IAcquisitionContext {
  acquisition_context_id: string
  clinic_id: string
  operatory_id: string
  patient_id: string
  set_by_user_id: string | null
  expires_at: string | null
}

export interface IUpsertAcquisitionContextPayload {
  operatory_id: string
  patient_id: string
  set_by_user_id?: string | null
  ttl_minutes?: number
}

/** Publish the patient currently open at an operatory (active-patient routing). */
export const upsertAcquisitionContextApi = async (
  payload: IUpsertAcquisitionContextPayload,
): Promise<ApiEnvelope<{ acquisition_context: IAcquisitionContext }>> => {
  const response = await axios.put<
    ApiEnvelope<{ acquisition_context: IAcquisitionContext }>
  >(BASE, payload)
  return response.data
}

/** Clear the active patient for an operatory (patient close / chair change). */
export const clearAcquisitionContextApi = async (
  operatoryId: string,
): Promise<ApiEnvelope<{ operatory_id: string; cleared: boolean }>> => {
  const response = await axios.delete<
    ApiEnvelope<{ operatory_id: string; cleared: boolean }>
  >(BASE, { params: { operatory_id: operatoryId } })
  return response.data
}

/** Read the active patient for an operatory; expired rows return null. */
export const getAcquisitionContextApi = async (
  operatoryId: string,
): Promise<
  ApiEnvelope<{ acquisition_context: IAcquisitionContext | null }>
> => {
  const response = await axios.get<
    ApiEnvelope<{ acquisition_context: IAcquisitionContext | null }>
  >(BASE, { params: { operatory_id: operatoryId } })
  return response.data
}
